/* eslint-disable indent */
import React from "react";
import { Row, Col } from "react-bootstrap";

const SMSPreviewBox = () => (
  <Row className="mb-2">
    <Col lg={6} md={6} sm={12}>
      <div
        className="p-3"
        style={{ border: "1px solid #000", backgroundColor: "#fff" }}
      >
        <div>From: +1 (485) 775-2619</div>
        <hr />
        <div className="font-weight-bold mb-2">Invitation</div>
        <div className="text-bubble text-bubble-bottom-left mb-4">
          <p className="mb-0">
            {
              "Hi {Candidate First Name}, as part of your application with {Company Name}, you've been invited to complete the next steps here: {URL} or check your email. Reply STOP to opt out."
            }
          </p>
        </div>
        <div className="font-weight-bold mb-2">Reminder</div>
        <div className="text-bubble text-bubble-bottom-left mb-2">
          <p className="mb-0">
            {
              "Hi {Candidate First Name}, reminder about your application with {Company Name}. Go to {URL} or check your email. Reply STOP to opt out."
            }
          </p>
        </div>
      </div>
    </Col>
  </Row>
);

export default SMSPreviewBox;
